export const shouldShowTrainingLink = (pathname: string) => !pathname.startsWith('/admin/');
